import { Alert } from '@mui/material';

const SavesOnTheFlyAlert = () => {
  return (
    <Alert severity="info">
      NOTE: Changes you make on this page will be saved on the fly to ensure data consistency.
    </Alert>
  );
};

export default SavesOnTheFlyAlert;
